import React, {useEffect, useRef, useState} from "react";
import useListContext from "../../tools/useListContext";
import {useModal} from "../../tools/useModal";
import {TransactionRepository} from "../../repository/AdminDashboard/transaction-Repository";
import toast from "react-hot-toast";

const TransactionContext = React.createContext();


export function TransactionProvider({children}) {
    const {
        handleUpdateListState, listState, onDevicePerPageChange, changePage, onSearchBtnClick
    } = useListContext(getItems)

    const [transactionChartData, setTransactionChartData] = useState({
        chartData: [],
        selectedTime: "بر اساس ماه جاری",
        selectedType: "تعداد تراکنش"
    })
    const prevChartDataRef = useRef(transactionChartData.chartData);
    const handleUpdateTransactionData = (key, value) => {
        setTransactionChartData(prev => ({...prev, [key]: value}));
    }

    async function getItems() {
        handleUpdateListState("loading", true)
        const response = await TransactionRepository.gettransaction(listState.searchQuery,
            listState.pageNumber, transactionChartData.selectedType, transactionChartData.selectedTime)
        handleUpdateListState("loading", false)
        if (!response.success) {
            toast.error(response.message);
            return;
        }

        handleUpdateListState("list", response.transactionList)
        handleUpdateListState("countAll", response.countAllPages)
        handleUpdateTransactionData("chartData", response.dataChart)


    }

    async function onDownloadFactorClick(event) {
        console.log("Event FACTOR : ", event)
        window.open('/invoice', '_blank');

        const response = await TransactionRepository.generateFactor(event.number)
        console.log("Response : ",response)
    }


    useEffect(() => {
        if (prevChartDataRef.current !== transactionChartData.chartData) {
            prevChartDataRef.current = transactionChartData.chartData;
            getItems();
        }
    }, [transactionChartData.selectedType, transactionChartData.selectedTime]);


    return (<TransactionContext.Provider value={{
            handleUpdateTransactionData,
            listState,
            handleUpdateListState,
            transactionChartData,
            changePage,
            onSearchBtnClick,
            onDownloadFactorClick
        }}>
            {children}
        </TransactionContext.Provider>
    )
}

export function useTransactionContext() {
    return React.useContext(TransactionContext);
}
